import React, { useRef, useEffect, useCallback, useContext } from "react";
import useState from "react-usestateref";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "semantic-ui-css/semantic.min.css";
import dayjs from "dayjs";
import Header from "./Header";
import { UserContext } from "../contexts/UserContext";
import Sidebar from "./Sidebar";
import BuyCryptoPage from "../pages/BuyCryptoPage";
import Select from "react-select";
import { Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount, useDisconnect } from "wagmi";
import { useTranslation } from "react-i18next";
import service from "../services/authservices";
import Web3 from "web3";
import i18n from "../translate/i18n";
import { tokenABI } from "./tokenABI";
import { tokenABI2 } from "./tokenABI2";
// const web3 = new Web3(window.ethereum);
// import { Web3Provider } from 'ethers';  // Correct import for v6.x
import { ethers } from "ethers"; // Import ethers for utility functions
const { utils } = ethers;
// const { Web3Provider } = ethers;

// const { JsonRpcProvider } = ethers.providers;
const bnbChainParamsMainnet = {
  chainId: "0x38", // Hexadecimal for 56 (BNB Chain Mainnet)
  chainName: "Binance Smart Chain",
  rpcUrls: ["https://bsc-dataseed.binance.org/"], // Mainnet RPC
  blockExplorerUrls: ["https://bscscan.com/"], // BNB Explorer
  nativeCurrency: {
    name: "Binance Coin",
    symbol: "BNB",
    decimals: 18,
  },
};

const bnbChainParamstestnet = {
  chainId: "0x61", // Hexadecimal for 97 (BSC Testnet)
  chainName: "Binance Smart Chain Testnet",
  rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"], // Testnet RPC
  blockExplorerUrls: ["https://testnet.bscscan.com/"], // Testnet BNB Explorer
  nativeCurrency: {
    name: "Binance Coin",
    symbol: "tBNB", // tBNB stands for testnet BNB
    decimals: 18,
  },
};

const bscProvider = new Web3.providers.HttpProvider(
  // "https://bsc-dataseed.binance.org/"
  "https://bsc-rpc.publicnode.com"
); // Public BSC Mainnet provider
const web3 = new Web3(bscProvider);

function DepositNew() {
  const { t } = useTranslation();
  const { i18nextLng } = useContext(UserContext);

  const [currency, setCurrency] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("useremail"));
  const [currencytrans, setcurrencyOptionstrans] = useState([]);
  // console.log(currencytrans.join(","), "setcurrencytrans===");
  const [privatecurrency, setprivateCurrency, privatecurrencyref] =
    useState("");
  const [fromCurrencyErr, setfromCurrencyErr, fromCurrencyErrref] =
    useState("");
  const [conversionPrice, setconversionPrice, conversionPriceref] = useState(0);
  // console.log(conversionPriceref.current, "conversionPriceref");
  const [selectFrom, setselectFrom, selectFromref] = useState({});

  const [toCurrencyErr, settoCurrencyErr, toCurrencyErrref] = useState("");
  const [toNetworkErr, settoNetworkErr, toNetworkErrref] = useState("");
  const [network, setNetwork] = useState("BEP20");
  const [networkTransak, setNetworkTransak] = useState("BEP20");
  const [fromAmount, setAmount, fromAmountref] = useState(0);
  const [toAmount, settoAmount, toAmountref] = useState(0);
  const [selectedFromCurr, setSelectedFromCurr] = useState("usdt");
  // console.log(selectedFromCurr, "selectedFromCurr");
  const [selectedTOCurr, setSelectedTOCurr] = useState("EUR");
  // console.log(selectedTOCurr, "selectedTOCurr==");
  const [walletAddress, setwalletAddress] = useState();
  const [buttonStatus, setbuttonStatus] = useState(false);
  const [loginCheck, setloginCheck] = useState(false);
  const [addressData, setAddressData] = useState(null);
  const [toastVisible, setToastVisible] = useState(false);
  const [dropdownKey, setDropdownKey] = useState(0);
  const [fromCurrency, setfromCurrencyRef, fromCurrencyRef] = useState([]);

  const [toCurrency, setToCurrencyRef, toCurrencyRef] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState([]);
  const [loading, setLoading] = useState(true);
  const coinTyperef = useRef(currency);
  const { theme } = useContext(UserContext);
  const [activeIndex, setActiveIndex] = useState(null);
  const [currencyOptions, setcurrencyOptions] = useState([]);
  const [validatemsg, setvalidatemsg, validatemsgref] = useState("");
  const [depositAmount, setdepositAmount, depositAmountref] = useState();
  const [walletLoader, setwalletLoader] = useState(false);
  const [tokenContractAddress, setcontract_address] = useState("");
  const [TxHash, setTxHash] = useState("");

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  useEffect(() => {
    if (i18nextLngs === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
    }
  }, [i18nextLngs]);

  const handleWalletConnect = () => {
    // console.log("===");
    if (isConnected) {
      showsuccessToast("Wallet connected successfully!");
      // toast.success('Wallet connected successfully!', {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
    }
  };

  // const tokenContractAddress = '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd';
  // const depositContractAddress = '0xBd68923c84aC6E8C2aFB7C7EFab577A494fB4E77';
  const depositContractAddress = "0xc8b08028cfbbCb2a613e4Ba2267d01528c69E1D8";

  //   const approveTokens = async () => {
  //     try {
  //       setwalletLoader(true);
  //         if (window.ethereum) {
  //             const web3 = new Web3(window.ethereum); // Use MetaMask's provider
  //             await window.ethereum.request({
  //                 method: 'wallet_addEthereumChain',
  //                 params: [bnbChainParamsMainnet],
  //             });
  //             const amountInWei = web3.utils.toWei(depositAmount, 'ether'); // Convert to Wei
  //             const tokenContract = new web3.eth.Contract(tokenABI, tokenContractAddress);
  //             const depositContract = new web3.eth.Contract(tokenABI2, depositContractAddress);
  //           await tokenContract.methods
  //                 .approve(depositContractAddress, amountInWei)
  //                 .send({ from: address })
  //                 .then(async(res)=>{
  //                   console.log(res,"Approval succes")
  //                   if(res.transactionHash  != null)
  //                   {
  //                     const deposit = await depositContract.methods
  //                     .deposit(tokenContractAddress, amountInWei)
  //                     .send({ from: address })
  //                     .then(async(res_deposit)=>{
  //                     console.log('deposit successful:', res_deposit)
  //                     if(res_deposit){
  //                       const data = {
  //                         currency: privatecurrencyref.current,
  //                         Amount: depositAmount,
  //                         address:address,
  //                         transactionHash:deposit.transactionHash,
  //                       };
  //                       console.log("===")
  //                       const response = await service.depositSubmit(data);
  //                           if (response.status) {
  //                         console.log(response,"ererer")
  //                           }
  //                       setdepositAmount(0);
  //                       setwalletLoader(false);
  //                       showsuccessToast("Transaction successfull");
  //                     }else{
  //                       setwalletLoader(false);
  //                       showErrorToast("Transaction Cancelled");
  //                     }
  //                   }).catch((err)=>{
  //                     setwalletLoader(false);
  //                     showErrorToast("Transaction Cancelled");
  //                    });
  //                   }
  //                   else
  //                   {
  //                     setwalletLoader(false);
  //                     showErrorToast("Transaction Cancelled");
  //                   }
  //                 })
  //                 .catch((err)=>{
  //                    setwalletLoader(false);
  //                    showErrorToast("Transaction Cancelled");
  //                   });
  //             } else {
  //                 showErrorToast("Transaction Cancelled");
  //                 console.error('No wallet detected. Please install MetaMask.');
  //             }
  //     } catch (error) {
  //         console.error('Error during approval:', error);
  //     }
  // };

  async function waitForTransaction(txHash, interval = 5000) {
    // console.log(`Checking transaction status for: ${txHash}`);

    while (true) {
      try {
        if (window.ethereum) {
          const web3 = new Web3(window.ethereum);
          let receipt = await web3.eth.getTransactionReceipt(txHash);
          if (receipt) {
            // console.log("Transaction confirmed", receipt);
            return receipt.status ? "Success" : "Failed";
          }
        } else {
          return "Failed";
        }
      } catch (error) {
        // console.error("Error fetching transaction receipt:", error);
        return "Failed";
      }

      // console.log("Transaction still pending... waiting 5 seconds");
      await new Promise((resolve) => setTimeout(resolve, interval));
    }
  }

  const get_quote = async () => {
    console.log(selectFromref.current, "selectFromref.current==");
    try {
      var data = {
        crypto: selectFromref.current.text,
        fiat: selectedTOCurr,
        network: selectFromref.current.network_name,
        amount: toAmountref.current ? toAmountref.current : "1",
      };
      const resp = await service.get_quote(data);

      if (resp.status) {
        setconversionPrice(resp.price);
        setAmount(resp.crypto);
      }
    } catch (error) {}
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value;
    if (name == "toAmount") {
      settoAmount(sanitizedValue);
      try {
        if (selectedTOCurr == "EUR" && sanitizedValue < 4) {
          // console.log("--");
          setfromCurrencyErr(
            "Minimum buy amount should be more than or equal to 4"
          );
        } else if (selectedTOCurr == "USD" && sanitizedValue < 5) {
          setfromCurrencyErr(
            "Minimum buy amount should be more than or equal to 5"
          );
        } else {
          setfromCurrencyErr("");
          settoCurrencyErr("");
          var data = {
            crypto: selectFromref.current.text,
            fiat: selectedTOCurr,
            network: selectFromref.current.network_name,
            amount: sanitizedValue,
          };

          const resp = await service.get_quote(data);
          if (resp.status) {
            setconversionPrice(resp.price);
            setAmount(resp.crypto);
          }
        }
        // console.log(fromCurrencyErrref.current, "fromCurrencyErrref");
      } catch (error) {
        // console.log("erro", error);
      }
    }
  };

  const clickButton = () => {
    if (fromAmountref.current === 0) {
      setfromCurrencyErr("Enter valid amount");
      setbuttonStatus(false);
    } else {
      setbuttonStatus(true);
    }
    if (toAmountref.current === 0) {
      setbuttonStatus(false);
      settoCurrencyErr("Enter valid amount");
    } else {
      setbuttonStatus(true);
    }
    if (networkTransak === "") {
      setbuttonStatus(false);
      settoNetworkErr("Please select the network ");
    } else {
      setbuttonStatus(true);
    }
  };

  const handleFromCurrencyChoose = async (e, { value }) => {
    setSelectedFromCurr(value);
    // console.log(value, "value===");
    const selected = fromCurrency.find((item) => item.value === value);
    setselectFrom(selected);
    // if (selectedFromCurr === "usdt") {
    if (value) {
      // console.log(networkTransak, "networkTransak===");
      const data = await service.getUserAddressNetwork(
        value,
        value === "usdt" ? networkTransak : "BEP20"
      );
      if (data.status) {
        setwalletAddress(data.data.address);
      } else {
      }
    }
    // }
    get_quote();
  };

  async function checkPendingTransaction(txHash) {
    try {
      const tx = await web3.eth.getTransaction(txHash);
      if (tx && !tx.blockNumber) {
        // console.log("Transaction is still pending ⏳");
        return "Failed";
      } else {
        // console.log("Transaction is confirmed ✅");
        return "Success";
      }
    } catch (error) {
      // console.error("Error fetching transaction:", error);
      return "Failed";
    }
  }

  async function getPendingTransactionsForAddress(address) {
    try {
      const web3 = new Web3(window.ethereum);
      const pendingBlock = await web3.eth.getBlock("pending", true);
      const myPendingTxs = pendingBlock.transactions.filter(
        (tx) => tx.from.toLowerCase() === address.toLowerCase()
      );

      // console.log("Your Pending Transactions:", myPendingTxs);
      return myPendingTxs;
    } catch (error) {
      // console.error("Error fetching pending transactions:", error);
      return [];
    }
  }

  const handleToCurrencyChoose = async (e, { value }) => {
    console.log("ssddcsdcsdc");
    setSelectedTOCurr(value);
    if (selectFromref.current && toAmountref.current && value) {
      var data = {
        crypto: selectFromref.current.text,
        fiat: value,
        network: selectFromref.current.network_name,
        amount: toAmountref.current ? toAmountref.current : "1",
      };
      const resp = await service.get_quote(data);

      if (resp.status) {
        setconversionPrice(resp.price);
        setAmount(resp.crypto);
      }
    }
  };
//jotthi wallet funciton start ==================================================
  const [account, setAccount] = useState(null);

  // const connectWallet = async () => {
    
  //   if (window.ethereum) {
  //     try {
  //       const accounts = await window.ethereum.request({
  //         method: "eth_requestAccounts",
  //       });
  //       console.log("accounts",accounts);
  //       await window.ethereum.request({
  //         method: "wallet_switchEthereumChain",
  //         params: [{ chainId: "0x38" }],//testNet BNB
  //       });
  //       setAccount(accounts[0]);
      
  //     } catch (error) {
  //       console.error("Error connecting to MetaMask:", error);
  //     }
  //   } else {
  //     alert("MetaMask is not installed. Please install it to connect.");
  //   }
  // };

//   const connectWallet = async () => {
//   if (window.ethereum) {
//     try {
//       // Request network switch first (optional, depends on use case)
//       await window.ethereum.request({
//         method: "wallet_switchEthereumChain",
//         params: [{ chainId: "0x61" }] // BNB Testnet chainId
//       });

//       // Then request accounts
//       const accounts = await window.ethereum.request({
//         method: "eth_requestAccounts"
//       });
      
//       if (accounts.length === 0) {
//         alert("No authorized account found. Please authorize this site in MetaMask.");
//         return;
//       }
      
//       setAccount(accounts[0]);
//     } catch (error) {
//       if (error.code === 4902) {
//         alert("The requested chain is not added to MetaMask.");
//       } else {
//         console.error("MetaMask connection error:", error);
//       }
//     }
//   } else {
//     alert("MetaMask is not installed. Please install it to connect.");
//   }
// };

const connectWallet = async () => {
  if (window.ethereum) {
    try {
      // Request accounts from MetaMask
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log("accounts", accounts);

      // Get the current chain ID
      const currentChainId = await window.ethereum.request({
        method: "eth_chainId",
      });
      console.log("Current chain ID:", currentChainId);

      // Check if it's not BNB Mainnet (chainId: 0x38)
      if (currentChainId !== "0x38") {
        try {
          // Request to switch to BNB Mainnet
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: "0x38" }],
          });
          console.log("Switched to BNB Mainnet");
        } catch (switchError) {
          // This error code indicates that the chain hasn't been added to MetaMask
          if (switchError.code === 4902) {
            alert("Please add BNB Mainnet to your MetaMask first.");
          } else {
            console.error("Error switching network:", switchError);
          }
          return;
        }
      } else {
        console.log("Already connected to BNB Mainnet");
      }

      // Set the account
      setAccount(accounts[0]);

    } catch (error) {
      console.error("Error connecting to MetaMask:", error);
    }
  } else {
    alert("MetaMask is not installed. Please install it to connect.");
  }
};


  
  const approveTokens = async () => {
    try {
      console.log("window.ethereum",await window.ethereum);
        try {
          if(!depositAmount){
             setvalidatemsg("amount is required");
          }else{
      if (window.ethereum) {

          setwalletLoader(true);
          const web3 = new Web3(window.ethereum); // Use MetaMask's provider
          console.log(web3)
          var last_hash;
         
          const networkId = await web3.eth.net.getId();
          console.log("Connected to network:", networkId);
          const amountInWei = web3.utils.toWei(depositAmount, "ether"); // Convert to Wei
          const tokenContract = new web3.eth.Contract(
            tokenABI,
            depositContractAddress
          );
          const depositContract = new web3.eth.Contract(
            tokenABI2,
            tokenContractAddress
          );

          // Step1: Approve the deposit contract

          const approvalTx = await tokenContract.methods
            .approve(tokenContractAddress, amountInWei)
            .send({ from: address });

          console.log(approvalTx,approvalTx.transactionHash, "Approval hash");

          last_hash = approvalTx.transactionHash;
          const tx = await web3.eth.getTransaction(approvalTx.transactionHash);
          await new Promise((resolve) => setTimeout(resolve, 5000));
          let pending_transactions = await getPendingTransactionsForAddress(
            address
          );
          if (+pending_transactions.length == 0) {
            const depositTx = await depositContract.methods
              .deposit(tokenContractAddress, amountInWei)
              .send({ from: address });
          const tx = await web3.eth.getTransaction(depositTx.transactionHash);

            if (tx) {
              // console.log("Deposit successful!");
              const data = {
                currency: privatecurrencyref.current,
                Amount: depositAmount,
                address: address,
                transactionHash: depositTx.transactionHash,
              };

              const response = await service.depositSubmit(data);
              if (response.status) {
                // console.log(response, "Deposit recorded in backend");
              }

              setdepositAmount(0);
              setwalletLoader(false);
              showsuccessToast("Transaction successful!");
              fetchTransactions();
            } else {
              showErrorToast("Deposit transaction failed.");
              setwalletLoader(false);
              return;
            }
          } else {
            showErrorToast("Approval transaction failed.");
            setwalletLoader(false);
            return;
          }}
         else {
        showErrorToast("No wallet detected. Please install MetaMask.");
        // console.error("No wallet detected. Please install MetaMask.");
      }  }
        } catch (error) {
          console.error("Transaction error:", error, error.message);
          if (
            error.message.includes(
              "smartTransaction:showSmartTransactionStatusPage"
            )
          ) {
            // console.log("last transaction hash ====", last_hash);
            if (last_hash != null) {
              const data = {
                currency: privatecurrencyref.current,
                Amount: depositAmount,
                address: address,
                transactionHash: last_hash,
              };

              const response = await service.depositSubmit(data);
              if (response.status) {
                // console.log(response, "Deposit recorded in backend");
              }

              setdepositAmount(0);
              setwalletLoader(false);
              showsuccessToast("Transaction successful!");
              fetchTransactions();
            }
          } else {
            showErrorToast("Transaction failed");
            setwalletLoader(false);
          }
        }
      
    } catch (error) {
      // console.error("Error during approval:", error);
    }
  };

  //  const approveTokensTest = async () => {
  //   try {
  //     setwalletLoader(true);
  //     if (window.ethereum) {
  //       try {
  //         const web3 = new Web3(window.ethereum); // Use MetaMask's provider
  //         console.log(web3)
  //         var last_hash;
         
  //         const networkId = await web3.eth.net.getId();
  //         console.log("Connected to network:", networkId);
  //         const amountInWei = web3.utils.toWei(depositAmount, "ether"); // Convert to Wei
  //         const tokenContract = new web3.eth.Contract(
  //           tokenABI,
  //           "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd" //Live==depositContractAddress
  //         );
  //         const depositContract = new web3.eth.Contract(
  //           tokenABI2,
  //           "0xBd68923c84aC6E8C2aFB7C7EFab577A494fB4E77"//Live==tokenContractAddress
  //         );

  //         // Step1: Approve the deposit contract

  //         const approvalTx = await tokenContract.methods
  //           .approve("0xBd68923c84aC6E8C2aFB7C7EFab577A494fB4E77", amountInWei)//Live==tokenContractAddress
  //           .send({ from: address });

  //         console.log(approvalTx,approvalTx.transactionHash, "Approval hash");

  //         last_hash = approvalTx.transactionHash;
  //         const tx = await web3.eth.getTransaction(approvalTx.transactionHash);
  //         await new Promise((resolve) => setTimeout(resolve, 5000));
  //         let pending_transactions = await getPendingTransactionsForAddress(
  //           address
  //         );
  //         if (+pending_transactions.length == 0) {
  //           const depositTx = await depositContract.methods
  //             .deposit("0x337610d27c682E347C9cD60BD4b3b107C9d34dDd", amountInWei)//Live==tokenContractAddress
  //             .send({ from: address });
  //         const tx = await web3.eth.getTransaction(depositTx.transactionHash);

  //           if (tx) {
  //             // console.log("Deposit successful!");
  //             const data = {
  //               currency: privatecurrencyref.current,
  //               Amount: depositAmount,
  //               address: address,
  //               transactionHash: depositTx.transactionHash,
  //             };

  //             const response = await service.depositSubmit(data);
  //             if (response.status) {
  //               // console.log(response, "Deposit recorded in backend");
  //             }

  //             setdepositAmount(0);
  //             setwalletLoader(false);
  //             showsuccessToast("Transaction successful!");
  //             fetchTransactions();
  //           } else {
  //             showErrorToast("Deposit transaction failed.");
  //             setwalletLoader(false);
  //             return;
  //           }
  //         } else {
  //           showErrorToast("Approval transaction failed.");
  //           setwalletLoader(false);
  //           return;
  //         }
  //       } catch (error) {
  //         console.error("Transaction error:", error, error.message);
  //         if (
  //           error.message.includes(
  //             "smartTransaction:showSmartTransactionStatusPage"
  //           )
  //         ) {
  //           // console.log("last transaction hash ====", last_hash);
  //           if (last_hash != null) {
  //             const data = {
  //               currency: privatecurrencyref.current,
  //               Amount: depositAmount,
  //               address: address,
  //               transactionHash: last_hash,
  //             };

  //             const response = await service.depositSubmit(data);
  //             if (response.status) {
  //               // console.log(response, "Deposit recorded in backend");
  //             }

  //             setdepositAmount(0);
  //             setwalletLoader(false);
  //             showsuccessToast("Transaction successful!");
  //             fetchTransactions();
  //           }
  //         } else {
  //           showErrorToast("Transaction failed");
  //           setwalletLoader(false);
  //         }
  //       }
  //     } else {
  //       showErrorToast("No wallet detected. Please install MetaMask.");
  //       // console.error("No wallet detected. Please install MetaMask.");
  //     }
  //   } catch (error) {
  //     // console.error("Error during approval:", error);
  //   }
  // };
//jotthi wallet funciton end ==================================================

  //             const amountInWei = web3.utils.toWei(depositAmount, 'ether'); // Convert to Wei
  //             const tokenContract = new web3.eth.Contract(tokenABI, tokenContractAddress);
  //             const depositContract = new web3.eth.Contract(tokenABI2, depositContractAddress);
  //             console.log("Approval funciton calll")

  //           await tokenContract.methods
  //                 .approve(depositContractAddress, amountInWei)
  //                 .send({ from: address })
  //                 .then(async(res)=>{
  //                   console.log(res,"Approval succes")
  //                   const deposit = await depositContract.methods
  //                   .deposit(tokenContractAddress, amountInWei)
  //                   .send({ from: address });
  //                   console.log('deposit successful:', deposit)
  //                   if(deposit){
  //                    console.log("deposit  funciton calll")
  //                     const data = {
  //                       currency: privatecurrencyref.current,
  //                       Amount: depositAmount,
  //                       address:address,
  //                       transactionHash:deposit.transactionHash,
  //                     };
  //                     console.log("===")
  //                     const response = await service.depositSubmit(data);
  //                         if (response.status) {
  //                       console.log(response,"ererer")
  //                         }
  //                     setwalletLoader(false);
  //                     showsuccessToast("Transaction successfull");
  //                   }else{
  //                     setwalletLoader(false);
  //                     showErrorToast("Transaction Cancelled");
  //                   }
  //                 })
  //                 .catch((err)=>{
  //                    setwalletLoader(false);
  //                    showErrorToast("Transaction Cancelled"), console.log(err,"0000000")});
  //             } else {
  //                 showErrorToast("Transaction Cancelled");
  //                 console.error('No wallet detected. Please install MetaMask.');
  //             }
  //           }else{
  //             setvalidatemsg("amount is required")
  //           }
  //     } catch (error) {
  //         console.error('Error during approval:', error);
  //     }
  // };

  const handleInputChange = async (e) => {
    var value = e.target.value;
    // console.log(value, "value");
    if (!value) {
      setvalidatemsg("amount is required");
    } else {
      setvalidatemsg("");
      setdepositAmount(value);
    }
    // console.log(depositAmountref.current, "depositAmount");
  };
  const fetchCurrencies = async () => {
    try {
      const data = await service.getDepositCurrency();
      var currency_data = [];
      for (let index = 0; index < data.get_currency.length; index++) {
        const element = data.get_currency[index];
        var obj = {
          value: element.currencySymbol,
          label: element.currencySymbol,
          text: element.currencySymbol,
          contract_address: element.contractAddress_bep20,
        };
        currency_data.push(obj);
      }
      setcurrencyOptions(currency_data);
    } catch (err) {
      // console.log(err);
    }
  };

  const fetchAddressData = async () => {
    try {
      const data = await service.getUserAddressNetwork(currency, network);
      if (data.status) {
        setAddressData(data.data);
      } else {
      }
    } catch (error) {
      // console.error("Error fetching address data:", error);
    }
  };
  const fetchAddressDataTransak = async () => {
    try {
      if (selectedFromCurr && networkTransak) {
        const data = await service.getUserAddressNetwork(
          selectedFromCurr,
          networkTransak
        );
        if (data.status) {
          setwalletAddress(data.data.address);
        } else {
        }
      }
    } catch (error) {
      // console.error("Error fetching address data:", error);
    }
  };

  const [faqs, setFaqs] = useState({});

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await service.getFaq();
        if (response.status) {
          // Filter FAQs with type 'Withdraw' only
          const withdrawFaqs = response.data.filter(
            (faq) => faq.type === "Deposit"
          );
          setFaqs(withdrawFaqs); // Store filtered FAQs directly
        } else {
          // console.error("Failed to fetch FAQs");
        }
      } catch (error) {
        // console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
    fetchCurrencies();
  }, []);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleDropdownReload = () => {
    setDropdownKey((prevKey) => prevKey + 1); // Change key to force re-render
  };

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const fetchTransactions = async () => {
    setLoading(true);
    setrefreshStatus(true);
    try {
      const response = await service.getDepositHistory();
      if (response.status) {
        if (Array.isArray(response.data) && response.data.length > 0) {
          // Filter unique transactions based on transactionId
          const uniqueTransactions = response.data.filter(
            (value, index, self) =>
              index ===
              self.findIndex((t) => t.transactionId === value.transactionId)
          );
          const totalAmount = uniqueTransactions.filter(
            (res) => coinTyperef.current === res.currency
          ); // Filter matching currency.reduce((sum, res) => sum + res.amount, 0);
          setTotalAmount(totalAmount);
          setTransactions(uniqueTransactions);
          setrefreshStatus(false);
        } else {
          setrefreshStatus(false);
          setTransactions([]);
        }
      } else {
        setrefreshStatus(false);
        setTransactions([]);
      }
    } catch (error) {
      // console.error("Error fetching transactions:", error);
      setTransactions([]);
      showErrorToast("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddressData();
    fetchTransactions();
  }, [currency, network]);
  useEffect(() => {
    fetchAddressDataTransak();
  }, [selectedFromCurr, networkTransak]);

  useEffect(() => {
    fetchDepositCurrencies();
  }, []);

  const refresh = () => {
    fetchTransactions();
  };

  const [refreshStatus, setrefreshStatus] = useState(false);

  const networkOptions = [
    { value: "BEP20", label: "BEP20" },
    { value: "TRC20", label: "TRC20" },
    // { value: "Matic", label: "MATIC" },
  ];

  const networkOptions_usdt = [
    { value: "BEP20", label: "BEP20" },
    // { value: "Matic", label: "MATIC" },
  ];

  const handleCopy = (txID) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    if (handleCopy.timeout) clearTimeout(handleCopy.timeout);

    handleCopy.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(txID)
        .then(() => {
          showsuccessToast(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">
                Transaction ID copied to clipboard!
              </p>
            </div>
          );
        })
        .catch((err) => {
          // console.error("Failed to copy text: ", err);
          showerrorToast(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy Transaction ID</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300);
  };

  const fetchDepositCurrencies = async () => {
    try {
      const res = await fetch("https://ipapi.co/json/");
      const { country_code: countryCode } = await res.json();

      const resp = await service.getDepositCurrencyTransak(countryCode);
      const transformedFromData = [];
      console.log(resp.currencies, "resp.currencies===");
      resp.currencies.forEach((item) => {
        transformedFromData.push({
          value: item.currencySymbol,
          key: item._id,
          text: item.currencySymbol,
          image: {
            avatar: true,
            src: item.Currency_image,
          },
          network_name: item.network_name,
          network_address: item.network_address,
        });
      });

      setfromCurrencyRef(transformedFromData);
      const selected = transformedFromData.find(
        (item) => item.value === selectedFromCurr
      );
      setselectFrom(selected);
      get_quote();
      // setcurrencyOptionstrans(symbols || []);
    } catch (err) {
      // console.error("Failed to fetch deposit currencies:", err);
    }
  };

  const handleCopyAdd = (address) => {
    if (handleCopy.toastVisible) return;

    handleCopy.toastVisible = true;

    // Prevent triggering multiple times rapidly
    if (handleCopyAdd.timeout) clearTimeout(handleCopyAdd.timeout);

    handleCopyAdd.timeout = setTimeout(() => {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          showsuccessToast(
            <div className="toast-ml">
              <h4 className="toast-title">Success!</h4>
              <p className="toast-message">Address copied to clipboard!</p>
            </div>
          );
        })
        .catch((err) => {
          // console.error("Failed to copy text: ", err);
          showerrorToast(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">Failed to copy address</p>
            </div>
          );
        })
        .finally(() => {
          setTimeout(() => {
            handleCopy.toastVisible = false;
          }, 2000);
        });
    }, 300); // 300ms debounce time
  };

  const select_currency = (value) => {
    setCurrency(value);
    coinTyperef.current = value;
  };

  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();

  const select_private_currency = (currency) => {
    // console.log("select private=====", currency);
    setprivateCurrency(currency.value);
    setcontract_address(currency.contract_address);
  };

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark");
      document.body.classList.remove("light");
    } else {
      document.body.classList.add("light");
      document.body.classList.remove("dark");
    }

    localStorage.setItem("theme", theme);
  }, [theme]);

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      padding: "4px",
      color: theme === "dark" ? "#fff" : "#000",
      boxShadow: "none",
      outline: "none",
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
        ? "#181a20"
        : "#fff",
      cursor: "pointer",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
    }),
  };

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  const [depositTab, setDepositTab] = useState("cryptodeposit");
  const [cryptoTab, setCryptoTab] = useState("usdt");

  const handleDepositChange = (tab) => {
    setDepositTab(tab);
  };

  const handleCryptoChange = (tab) => {
    setCryptoTab(tab);
  };

  return (
    <>
      <Header />

      <div className="deposit-section">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("Deposit")}</span>
              <div className="row mt-4">
                <div className="col-lg-7">
                  <div className="nw-dep-lft">
                    <div className="nw-dep-top">
                      <span
                        className={`nw-dep-tab-btn ${
                          depositTab === "cryptodeposit" ? "active" : ""
                        }`}
                        onClick={() => handleDepositChange("cryptodeposit")}
                      >
                        {t("CryptoDeposit")}
                      </span>
                      <span
                        className={`nw-dep-tab-btn ${
                          depositTab === "privatedeposit" ? "active" : ""
                        }`}
                        onClick={() => handleDepositChange("privatedeposit")}
                      >
                        {t("PrivateDeposit")}
                      </span>
                      {/* <span
                        className={`nw-dep-tab-btn ${
                          depositTab === "buycrypto" ? "active" : ""
                        }`}
                        onClick={() => handleDepositChange("buycrypto")}
                      >
                        Buy Crypto
                      </span> */}
                    </div>

                    {depositTab === "cryptodeposit" && (
                      <>
                        <>
                          <div className="nw-dep-main">
                            <div>
                              <h6 className="home-viewasset-span nw-dp-mb-12">
                                {t("SelectCrypto")}
                              </h6>

                              <div className="depo_inner_divmain">
                                <Select
                                  options={currencyOptions}
                                  styles={customStyles}
                                  // key={dropdownKey}
                                  onChange={(e) => select_currency(e.value)}
                                  className="withdraw-dropdown-menu "
                                />
                              </div>

                              {/* <div className="nw-dep-crypt-tab nw-dp-mb-24">
                              <button
                                className={`nw-dep-crypt-tab-btn ${
                                  cryptoTab === "usdt" ? "active" : ""
                                }`}
                                onClick={() => handleCryptoChange("usdt")}
                              >
                                <span>
                                  <img
                                    src={require("../assests/usdt.webp")}
                                    alt=""
                                    className={`dp-crypt-icon ${
                                      cryptoTab === "usdt" ? "active" : ""
                                    }`}
                                  />
                                </span>
                                usdt
                              </button>

                              <button
                                className={`nw-dep-crypt-tab-btn ${
                                  cryptoTab === "usdt" ? "active" : ""
                                }`}
                                onClick={() => handleCryptoChange("usdt")}
                              >
                                <span>
                                  <img
                                    src={require("../assests/usdt.webp")}
                                    alt=""
                                    className={`dp-crypt-icon ${
                                      cryptoTab === "usdt" ? "active" : ""
                                    }`}
                                  />
                                </span>
                                usdt
                              </button>
                            </div> */}
                            </div>
                            {coinTyperef.current ? (
                              <>
                                <div>
                                  <h6 className="home-viewasset-span nw-dp-mb-12">
                                    {t("SelectNetwork")}
                                  </h6>

                                  {coinTyperef.current === "usdt" ? (
                                    <Select
                                      options={networkOptions}
                                      styles={customStyles}
                                      key={dropdownKey}
                                      onChange={(e) => setNetwork(e.value)}
                                      className="withdraw-dropdown-menu"
                                    />
                                  ) : (
                                    <Select
                                      options={networkOptions_usdt}
                                      styles={customStyles}
                                      key={dropdownKey}
                                      onChange={(e) => setNetwork(e.value)}
                                      className="withdraw-dropdown-menu nw-dp-mb-16"
                                    />
                                  )}
                                </div>

                                <div className="depo_in_notesdiv nw-dp-mb-24">
                                  <div className="depoin_notes_icon">
                                    <i class="bi bi-exclamation-triangle depo_note_ico"></i>
                                  </div>
                                  <div className="depo_notes_defspan">
                                    {t("OnlyDeposit")}{" "}
                                    {coinTyperef?.current || "your currency"}{" "}
                                    {t("ToThe")}
                                    {network || "correct"}
                                    {t("NetworkDepositing")}
                                  </div>
                                </div>

                                <div className="depo_inner_divmain">
                                  <span className="home-viewasset-span">
                                    {t("NetworkAddress")}
                                  </span>
                                  <div className="depo_qr_maindiv">
                                    {addressData ? (
                                      <>
                                        <div className="depo_qr_imgmain">
                                          <div className="depo_qr_imgsize">
                                            <img
                                              src={addressData.qrcode}
                                              alt="QR code"
                                              className="QR-depo-img"
                                            />
                                          </div>
                                          <span className="scan_or_enter">
                                            {t("ScanTheQRCode")}
                                          </span>
                                        </div>
                                        <div className="depo_add_dis">
                                          <span className="address_span">
                                            {addressData.address}
                                          </span>
                                          <i
                                            className="ri-file-copy-line cursor-pointer add_depo_copy"
                                            onClick={() =>
                                              handleCopyAdd(addressData.address)
                                            }
                                          ></i>
                                        </div>

                                        <div className="depo_add_disbal">
                                          <span className="address_spanbalance">
                                            {"Available Balance"}
                                          </span>
                                          <span className="address_balancedata">
                                            {parseFloat(
                                              addressData.balance
                                            ).toFixed(8)}
                                          </span>
                                        </div>
                                      </>
                                    ) : (
                                      <div className="loader_main loader_mainChange">
                                        <ScaleLoader
                                          color="#20A1FD"
                                          height={10}
                                          width={3}
                                        />
                                        <p>{t("Loading")}</p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            {/* {coinTyperef.current ? (
                        <>
                          <div className="depo_inner_divmain">
                            <h6 className="home-viewasset-span nw-dp-mb-12">
                              Select Network
                            </h6>
                            {coinTyperef.current === "usdt" ? (
                              <Select
                                options={networkOptions}
                                styles={customStyles}
                                key={dropdownKey}
                                onChange={(e) => setNetwork(e.value)}
                                className="withdraw-dropdown-menu"
                              />
                            ) : (
                              <Select
                                options={networkOptions_usdt}
                                styles={customStyles}
                                key={dropdownKey}
                                onChange={(e) => setNetwork(e.value)}
                                className="withdraw-dropdown-menu"
                              />
                            )}
                          </div>
                          <div className="depo_in_notesdiv">
                            <div className="depoin_notes_icon">
                              <i class="bi bi-exclamation-triangle depo_note_ico"></i>
                            </div>
                            <div className="depo_notes_defspan">
                              Only deposit{" "}
                              {coinTyperef?.current || "your currency"} to the{" "}
                              {network || "correct"} network. Depositing any
                              other cryptocurrency or using a different network
                              may result in the permanent loss of your funds.
                            </div>
                          </div>
                          <div className="depo_inner_divmain">
                            <span className="home-viewasset-span">
                              Network Address
                            </span>
                            <div className="depo_qr_maindiv">
                              {addressData ? (
                                <>
                                  <div className="depo_qr_imgmain">
                                    <div className="depo_qr_imgsize">
                                      <img
                                        src={addressData.qrcode}
                                        alt="QR code"
                                        className="QR-depo-img"
                                      />
                                    </div>
                                    <span className="scan_or_enter">
                                      Scan the QR code or copy the address to
                                      deposit
                                    </span>
                                  </div>
                                  <div className="depo_add_dis">
                                    <span className="address_span">
                                      {addressData.address}
                                    </span>
                                    <i
                                      className="ri-file-copy-line cursor-pointer add_depo_copy"
                                      onClick={() =>
                                        handleCopyAdd(addressData.address)
                                      }
                                    ></i>
                                  </div>

                                  <div className="depo_add_disbal">
                                    <span className="address_spanbalance">
                                      {"Available Balance"}
                                    </span>
                                    <span className="address_balancedata">
                                      {addressData.balance}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="loader_main loader_mainChange">
                                  <ScaleLoader
                                    color="#20A1FD"
                                    height={10}
                                    width={3}
                                  />
                                  <p>Loading...</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )} */}
                          </div>
                        </>
                      </>
                    )}

                    {depositTab === "privatedeposit" && (
                      <>
                        <>
                          <div className="nw-dep-main">
                            <div>
                              <h6 className="home-viewasset-span nw-dp-mb-12">
                                {t("SelectCrypto")}
                              </h6>

                              {/* <div className="depo_inner_divmain">
                          <Select
                            options={currencyOptions}
                            styles={customStyles}
                            onChange={(e) => select_currency(e.value)}
                            className="withdraw-dropdown-menu"
                          />
                        </div> */}

                              {/* <div className="nw-dep-crypt-tab nw-dp-mb-24">
                              <button
                                className={`nw-dep-crypt-tab-btn ${
                                  cryptoTab === "usdt" ? "active" : ""
                                }`}
                                onClick={() => handleCryptoChange("usdt")}
                              >
                                <span>
                                  <img
                                    src={require("../assests/usdt.webp")}
                                    alt=""
                                    className={`dp-crypt-icon ${
                                      cryptoTab === "usdt" ? "active" : ""
                                    }`}
                                  />
                                </span>
                                usdt
                              </button>
                              <button
                                className={`nw-dep-crypt-tab-btn ${
                                  cryptoTab === "usdt" ? "active" : ""
                                }`}
                                onClick={() => handleCryptoChange("usdt")}
                              >
                                <span>
                                  <img
                                    src={require("../assests/usdt.webp")}
                                    alt=""
                                    className={`dp-crypt-icon ${
                                      cryptoTab === "usdt" ? "active" : ""
                                    }`}
                                  />
                                </span>
                                usdt
                              </button>
                            </div> */}
                              <div className="depo_inner_divmain">
                                <Select
                                  options={currencyOptions}
                                  styles={customStyles}
                                  // key={dropdownKey}
                                  onChange={select_private_currency}
                                  className="withdraw-dropdown-menu"
                                />
                              </div>
                            </div>
                            {!privatecurrencyref.current ? (
                              ""
                            ) : (
                              <>
                                {/* <div>
                              <h6 className="home-viewasset-span nw-dp-mb-12">
                                Select Network
                              </h6>

                              {coinTyperef.current === "usdt" ? (
                                <Select
                                  options={networkOptions}
                                  styles={customStyles}
                                  key={dropdownKey}
                                  onChange={(e) => setNetwork(e.value)}
                                  className="withdraw-dropdown-menu"
                                />
                              ) : (
                                <Select
                                  options={networkOptions_usdt}
                                  styles={customStyles}
                                  key={dropdownKey}
                                  onChange={(e) => setNetwork(e.value)}
                                  className="withdraw-dropdown-menu nw-dp-mb-16"
                                />
                              )}
                            </div>

                            <div className="depo_in_notesdiv nw-dp-mb-24">
                              <div className="depoin_notes_icon">
                                <i class="bi bi-exclamation-triangle depo_note_ico"></i>
                              </div>
                              <div className="depo_notes_defspan">
                                Only deposit{" "}
                                {coinTyperef?.current || "your currency"} to the{" "}
                                {network || "correct"} network. Depositing any
                                other cryptocurrency or using a different
                                network may result in the permanent loss of your
                                funds.
                              </div>
                            </div> */}

                                <div className="depo_inner_divmain">
                                  <h6 className="home-viewasset-span nw-dp-mb-12 mt-3">
                                    {t("DepositAmount")}
                                  </h6>
                                  <div className="nw-dp-inp-wrap nw-dp-mb-24">
                                    <input
                                      type="number"
                                      min={0}
                                      placeholder={t("EnterTheAmount")}
                                      className="nw-dp-inp"
                                      onChange={handleInputChange}
                                    />
                                    <span className="nw-dp-inp-span">
                                      {privatecurrencyref.current}
                                    </span>
                                    <span className="error">
                                      {validatemsgref.current
                                        ? validatemsgref.current
                                        : ""}
                                    </span>
                                  </div>
                                </div>

                                <ConnectButton.Custom>
                                  {({
                                    openConnectModal,
                                    account,
                                    chain,
                                    authenticationStatus,
                                    mounted,
                                  }) => {
                                    const ready =
                                      mounted &&
                                      authenticationStatus !== "loading";
                                    const connected = ready && account && chain;

                                    return (
                                      <>
                                        {!address ? (
                                          <button
                                            className="head-btn-login resp_100"
                                             style={{ width: "120px" }}
                                            // className="head-btn"
                                            // style={{ width: "150px" }}
                                            // onClick={() => {
                                            //   openConnectModal();
                                            //   handleWalletConnect();
                                            // }}
                                            onClick={connectWallet}
                                          >
                                            <span className="head-btn-now">
                                              {t("ConnectWallet")}
                                            </span>
                                            <span className="head-btn-new">
                                              {t("ConnectWallet")}
                                            </span>
                                          </button>
                                        ) : walletLoader == true ? (
                                          <>
                                            <button
                                            className="head-btn-login resp_100"
                                             style={{ width: "120px" }}
                                            >
                                              <span className="head-btn-now">
                                                {t("Loading")}
                                              </span>
                                              <span className="head-btn-new">
                                                {t("Loading")}
                                              </span>
                                            </button>
                                          </>
                                        ) : (
                                          <>
                                            <button
                                             className="head-btn-login resp_100"
                                             style={{ width: "120px" }}
                                              onClick={approveTokens}
                                            >
                                              <span className="head-btn-now">
                                                {t("Deposit")}
                                              </span>
                                              <span className="head-btn-new">
                                                {t("Deposit")}
                                              </span>
                                            </button>
                                          </>
                                        )}
                                      </>

                                      // <button className="dep-wl-btn">Connect Wallet</button>
                                    );
                                  }}
                                </ConnectButton.Custom>
                              </>
                            )}
                            {/* {coinTyperef.current ? (
                        <>
                          <div className="depo_inner_divmain">
                            <h6 className="home-viewasset-span nw-dp-mb-12">
                              Select Network
                            </h6>
                            {coinTyperef.current === "usdt" ? (
                              <Select
                                options={networkOptions}
                                styles={customStyles}
                                key={dropdownKey}
                                onChange={(e) => setNetwork(e.value)}
                                className="withdraw-dropdown-menu"
                              />
                            ) : (
                              <Select
                                options={networkOptions_usdt}
                                styles={customStyles}
                                key={dropdownKey}
                                onChange={(e) => setNetwork(e.value)}
                                className="withdraw-dropdown-menu"
                              />
                            )}
                          </div>
                          <div className="depo_in_notesdiv">
                            <div className="depoin_notes_icon">
                              <i class="bi bi-exclamation-triangle depo_note_ico"></i>
                            </div>
                            <div className="depo_notes_defspan">
                              Only deposit{" "}
                              {coinTyperef?.current || "your currency"} to the{" "}
                              {network || "correct"} network. Depositing any
                              other cryptocurrency or using a different network
                              may result in the permanent loss of your funds.
                            </div>
                          </div>
                          <div className="depo_inner_divmain">
                            <span className="home-viewasset-span">
                              Network Address
                            </span>
                            <div className="depo_qr_maindiv">
                              {addressData ? (
                                <>
                                  <div className="depo_qr_imgmain">
                                    <div className="depo_qr_imgsize">
                                      <img
                                        src={addressData.qrcode}
                                        alt="QR code"
                                        className="QR-depo-img"
                                      />
                                    </div>
                                    <span className="scan_or_enter">
                                      Scan the QR code or copy the address to
                                      deposit
                                    </span>
                                  </div>
                                  <div className="depo_add_dis">
                                    <span className="address_span">
                                      {addressData.address}
                                    </span>
                                    <i
                                      className="ri-file-copy-line cursor-pointer add_depo_copy"
                                      onClick={() =>
                                        handleCopyAdd(addressData.address)
                                      }
                                    ></i>
                                  </div>

                                  <div className="depo_add_disbal">
                                    <span className="address_spanbalance">
                                      {"Available Balance"}
                                    </span>
                                    <span className="address_balancedata">
                                      {addressData.balance}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <div className="loader_main loader_mainChange">
                                  <ScaleLoader
                                    color="#20A1FD"
                                    height={10}
                                    width={3}
                                  />
                                  <p>Loading...</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )} */}
                          </div>
                        </>
                      </>
                    )}

                    {depositTab === "buycrypto" && (
                      <>
                        <div className="nw-dep-main">
                          <div className="buy_crypto_head">
                            <h6 className="home-viewasset-span nw-dp-mb-12 font_buy_transak">
                              {t("Buy")}
                            </h6>
                            <div className="swap_lft_top">
                              <div className="foot_frst">
                                <span className="bals_divs_insubhead">
                                  {"Pay"}
                                </span>
                                <input
                                  type="number"
                                  name="toAmount"
                                  min="0"
                                  placeholder="0.00"
                                  value={toAmountref.current}
                                  onChange={handleChange}
                                  onWheel={(e) => e.target.blur()}
                                  className="swap_in_val dark-text-white"
                                />
                              </div>
                              <div className="swap_chng_frst">
                                <div className=" Swapcard swap_drop_all">
                                  {/* <Dropdown
                                    placeholder={"Select-Coin"}
                                    fluid
                                    selection
                                    options={toCurrencyRef.current}
                                    onChange={handleToCurrencyChoose}
                                    defaultValue={selectedTOCurr}
                                  /> */}

                                  <Dropdown
                                    placeholder={"Select-Coin"}
                                    fluid
                                    selection
                                    options={[
                                      {
                                        key: "usd",
                                        text: (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <img
                                              src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1727957555/bh0vsmct8thqn84ync8t.png"
                                              alt="USD"
                                              style={{
                                                width: 20,
                                                marginRight: 8,
                                              }}
                                            />
                                            {t("USD")}
                                          </div>
                                        ),
                                        value: "USD",
                                      },
                                      {
                                        key: "eur",
                                        text: (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <img
                                              src="https://res.cloudinary.com/dpnvbcrn2/image/upload/v1728381210/cosxatjvmy7ih0vxrsjq.png"
                                              alt="EUR"
                                              style={{
                                                width: 25,
                                                marginRight: 8,
                                              }}
                                            />
                                            {t("EUR")}
                                          </div>
                                        ),
                                        value: "EUR",
                                      },
                                    ]}
                                    onChange={handleToCurrencyChoose}
                                    defaultValue={selectedTOCurr}
                                  />
                                </div>
                              </div>
                            </div>
                            <p className="errorcss">
                              {" "}
                              {toCurrencyErrref.current}
                            </p>

                            <div className="swap_mid">
                              <i
                                class="fa-solid fa-circle-down"
                                // style="color: #20a1fd;"
                              ></i>
                            </div>

                            <div className="swap_lft_top">
                              <div className="foot_frst">
                                <span className="bals_divs_insubhead">
                                  {"Receive"}
                                </span>
                                <input
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  min="0"
                                  placeholder="0.00"
                                  value={fromAmountref.current}
                                  className="swap_in_val dark-text-white"
                                />
                              </div>
                              <div className="swap_chng_frst">
                                <div className=" Swapcard swap_drop_all">
                                  <Dropdown
                                    placeholder={"Select-Coin"}
                                    fluid
                                    selection
                                    options={fromCurrencyRef.current}
                                    onChange={handleFromCurrencyChoose}
                                    defaultValue={selectedFromCurr}
                                  />
                                </div>
                              </div>
                            </div>
                            <p className="errorcss">
                              {" "}
                              {fromCurrencyErrref.current}
                            </p>

                            {selectedFromCurr === "usdt" && (
                              <>
                                <div className="mb-2 mt-4">
                                  <h6 className="home-viewasset-span nw-dp-mb-12">
                                    {t("SelectNetwork")}
                                  </h6>

                                  <Select
                                    options={networkOptions}
                                    styles={customStyles}
                                    key={dropdownKey}
                                    onChange={(e) => {
                                      setNetworkTransak(e.value);
                                      toNetworkErrref.current = "";
                                    }}
                                    className="withdraw-dropdown-menu"
                                  />
                                </div>
                                <p className="errorcss">
                                  {" "}
                                  {toNetworkErrref.current}
                                </p>
                              </>
                            )}

                            <div className="swap-footers">
                              <div className="swap-footL">
                                {" "}
                                <span>{"Price"}</span>
                              </div>
                              <div className="swap-footL">
                                {" "}
                                1 {selectedFromCurr} ={" "}
                                {parseFloat(conversionPriceref.current).toFixed(
                                  8
                                )}{" "}
                                {selectedTOCurr}{" "}
                              </div>
                            </div>

                            {selectedFromCurr === "" ||
                            selectedTOCurr === "" ||
                            fromAmountref.current == 0 ||
                            toAmountref.current == 0 ||
                            (selectedFromCurr === "usdt" && !networkTransak) ? (
                              <div className="buywith_cards">
                                <div
                                  className="text-white log-button"
                                  aria-disabled
                                  onClick={clickButton}
                                >
                                  {t("BuyWithCard")}
                                </div>
                              </div>
                            ) : (
                              <div className="buywith_cards">
                                <BuyCryptoPage
                                  fromCurrency={selectedFromCurr}
                                  toCurrency={selectedTOCurr}
                                  walletAddress={walletAddress}
                                  email={email}
                                  fiatAmount={toAmountref.current}
                                  network={
                                    networkTransak ||
                                    selectFromref.current.network_name
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className="col-lg-5">
                  <div className="container m-top-20 p-0">
                    <div
                      className="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      <div className="faq">
                        <h5 className=" -title">{t("FAQs")}</h5>
                        {faqs.length > 0 ? (
                          faqs.map((faq, index) => (
                            <div
                              className="accordion-item font-satoshi"
                              key={faq._id}
                            >
                              <h2
                                className="accordion-header"
                                id={`flush-heading-${index}`}
                              >
                                <button
                                  className={`accordion-button ${
                                    activeIndex === index ? "" : "collapsed"
                                  }`}
                                  type="button"
                                  onClick={() => handleToggle(index)}
                                  aria-expanded={
                                    activeIndex === index ? "true" : "false"
                                  }
                                  aria-controls={`flush-collapse-${index}`}
                                >
                                  {index + 1}. {faq.question}
                                  <span className="icon">
                                    <i
                                      className={`fas ${
                                        activeIndex === index
                                          ? "fa-chevron-up"
                                          : "fa-chevron-down"
                                      }`}
                                    ></i>
                                  </span>
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse-${index}`}
                                className={`accordion-collapse collapse ${
                                  activeIndex === index ? "show" : ""
                                }`}
                                aria-labelledby={`flush-heading-${index}`}
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">
                                  {faq.status === "Active"
                                    ? faq.answer
                                    : "Content not available."}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="faq2">
                            <span className="faq_cate_span">
                              {t("NoFAQsAvailable")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="recent_depo_main">
                <div className="manage_btn_row">
                  <span className="home_right_marketspan">
                    {t("RecentDeposit")}
                    {refreshStatus == true ? (
                      <i className="fa-solid fa-arrows-rotate fa-spin das2"></i>
                    ) : (
                      <i
                        className="fa-solid fa-arrows-rotate cursor-pointer das2"
                        onClick={refresh}
                      ></i>
                    )}
                  </span>
                  <Link to="/deposithistory">
                    <div className="d-flex align-items-center gap-2 cursor-pointer">
                      <span className="home_starty_view">{t("ViewAll")}</span>
                      <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                    </div>
                  </Link>
                </div>
                <div className="recent_depo_tablemain pb-0">
                  <div className="table-responsive table-borderless home_recent_table">
                    {loading ? (
                      <div className="loader_main loader_mainChange">
                        <ScaleLoader color="#20A1FD" height={10} width={3} />
                        <p>{t("Loading")}</p>
                      </div>
                    ) : (
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="text_left">{t("Currency")}</th>
                            <th>{t("Date&Time")}</th>
                            <th>{t("Network")}</th>
                            <th>{t("Amount")}</th>
                            <th>{t("Type")}</th>
                            <th>{t("TransactionID")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions.length > 0 ? (
                            transactions
                              .slice(0, 5)
                              .map((transaction, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="home_recent_firstdata">
                                      <img
                                        src={
                                          transaction.currency === "usdt"
                                            ? require("../assests/usdt-logo.png")
                                            : transaction.currency === "usdt"
                                            ? require("../assests/usdt-logo.png")
                                            : require("../assests/usdt-logo.png")
                                        }
                                        alt={transaction.currency}
                                        className="usdt_home_recent"
                                      />
                                      <span>{transaction.currency}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <span>
                                      {isNaN(new Date(transaction.date))
                                        ? "null"
                                        : dayjs(transaction.date).format(
                                            "DD MMMM YYYY, hh:mm A"
                                          )}
                                    </span>
                                  </td>
                                  <td>
                                    <span>{transaction.network}</span>
                                  </td>
                                  <td>
                                    <span>{transaction.amount}</span>
                                  </td>
                                  <td>
                                    <span>{transaction.type}</span>
                                  </td>
                                  <td>
                                    <div className="home_uid_main">
                                      <span>{transaction.transactionId}</span>
                                      <i
                                        className="ri-file-copy-line cursor-pointer uid_copy_recent"
                                        onClick={() => {
                                          handleCopy(transaction.transactionId);
                                        }}
                                      ></i>
                                    </div>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="5">
                                <span className="depo_no_record">
                                  {t("NoTransactionsFound")}
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DepositNew;

          